import { useTranslation } from 'react-i18next';
import { usePTPConfigContext } from 'GlobalConfig.context';
import { Stack } from 'components/Stack';
import { useLineItemCommonDisplayInfo } from '../../../../../../hooks';
import { ReturnLineItem } from '../../../../../../interfaces';
import { ProductImage, SIZES } from '../../../../../ProductImage';
import {
  ItemInfo,
  ItemInfoLabel,
  ProductName,
  ProductNameItem,
} from './LineItem.styles';
import { useDetectDevice } from '../../../../../../../../../../hooks';

interface LineItemProps {
  returnLineItem: ReturnLineItem;
}

export const LineItem = ({ returnLineItem }: LineItemProps): JSX.Element => {
  const ptpConfig = usePTPConfigContext();
  const { t } = useTranslation();
  const { isMobile } = useDetectDevice();
  const { item: lineItem, reason, quantity, customReason } = returnLineItem;
  const { productImageUrl, productPrice, productName, additionalInformation } =
    useLineItemCommonDisplayInfo(lineItem);

  const itemInfo = [
    {
      label: t('LINE_ITEMS_QUANTITY'),
      value: quantity,
    },
    {
      label: t('reason'),
      value: t(reason.value),
    },
    {
      label: t('SPECIFY'),
      value: customReason,
    },
  ].filter((item) => !!item);

  return (
    <Stack direction="row" gap={16}>
      {productImageUrl && (
        <ProductImage
          size={SIZES.sm}
          src={productImageUrl}
          lineItemConfig={ptpConfig.lineItem}
          alt={productName}
        />
      )}
      <Stack direction="column" gap={8} flex={1}>
        {isMobile ? (
          <>
            <ProductName>{productName}</ProductName>
            <ItemInfo>{productPrice?.value}</ItemInfo>
          </>
        ) : (
          <ProductName>
            <ProductNameItem>{productName} </ProductNameItem>
            <ItemInfo>{productPrice?.value}</ItemInfo>
          </ProductName>
        )}
        {additionalInformation && <ItemInfo>{additionalInformation}</ItemInfo>}
        <Stack wrap gap={8}>
          {itemInfo.map(
            ({ label, value }) =>
              value && (
                <ItemInfo>
                  <ItemInfoLabel>{label}:</ItemInfoLabel> {value}
                </ItemInfo>
              ),
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};
